import React, { useState } from 'react';
import { TextField, FormLabel, CircularProgress, InputAdornment } from '@mui/material';
import { CLIENT_ERROR, CLIENT_NAME, OWNER_DOC_ID } from '../validationSchema';
import { useFormikHelper } from '@/hooks/useFormikHelper';
import { useLazyCheckClientExistsInInsightQuery } from '@/features/clients/clientsApi';
import { useFormikContext } from 'formik';

export const ClientNameField = ({ formik, loading }) => {
	const { values, getFieldProps, setFieldValue } = formik ?? useFormikContext();
	const { getError, getErrorMessage } = useFormikHelper(formik);

	const userId = values[OWNER_DOC_ID];

	const [errorMessage, setErrorMessage] = useState('');

	const [checkClientExists, { isLoading }] = useLazyCheckClientExistsInInsightQuery();

	return (
		<>
			<FormLabel htmlFor='client-name' required>
				{'Client'}
			</FormLabel>
			<TextField
				id='client-name'
				fullWidth
				{...getFieldProps(CLIENT_NAME)}
				error={getError(CLIENT_NAME) || errorMessage.length > 0}
				helperText={errorMessage.length > 0 ? errorMessage : getErrorMessage(CLIENT_NAME)}
				disabled={loading}
				required
				name={CLIENT_NAME}
				InputProps={{
					...(isLoading && {
						endAdornment: (
							<InputAdornment position='end'>
								<CircularProgress size='1em' />
							</InputAdornment>
						),
					}),
				}}
				onBlur={async () => {
					if (values[CLIENT_NAME].length > 0) {
						const res = await checkClientExists({
							userId,
							companyName: values[CLIENT_NAME],
						}).unwrap();
						setFieldValue(CLIENT_ERROR, res.length > 0);
						setErrorMessage(
							res.length > 0
								? `${values[CLIENT_NAME]} already exists as a client in your brokerage`
								: '',
						);
					}
				}}
			/>
		</>
	);
};
